import { useState, useLayoutEffect, useRef } from 'react';

const FRAME_HEIGHT = 68;

const useStickyBarWithOffset = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [stickBarFixed, setStickyBarFixed] = useState(false);

  const onScroll = () => {
    const top = ref?.current?.getBoundingClientRect().top;

    if (top && top <= FRAME_HEIGHT) {
      setStickyBarFixed(true);
    }

    if (top && top > FRAME_HEIGHT) {
      setStickyBarFixed(false);
    }
  };

  useLayoutEffect(() => {
    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return [ref, stickBarFixed];
};

export default useStickyBarWithOffset;
